import React from 'react';

import 'ol/ol.css';
import 'ol-layerswitcher/src/ol-layerswitcher.css';

import Map from 'ol/Map.js';
import {Group, Image as ImageLayer, Tile as TileLayer, VectorTile as VectorTileLayer} from 'ol/layer';
import {VectorTile, XYZ} from 'ol/source'; //BingMaps, 
import RasterSource from 'ol/source/Raster';
import {Fill, Style, Text} from 'ol/style';
import View from 'ol/View.js';
import {MVT} from 'ol/format';
import {fromLonLat, toLonLat} from 'ol/proj';
//import TileGrid from 'ol/tilegrid/TileGrid';
import Control from 'ol/control/Control';
import {FullScreen, Rotate, ScaleLine, Zoom} from 'ol/control';
import {DragRotateAndZoom, defaults as defaultInteractions} from 'ol/interaction';
import {easeOut, inAndOut} from 'ol/easing';
import LayerSwitcher from 'ol-layerswitcher';

class GenericControl extends Control {
  constructor(element, clickCallback) {
    super({
      element: element,
//      target: options.target
    });
    element.addEventListener('click', (e) => {
      clickCallback();
//      window.gtag('event', 'mapbutton', { 'event_category': 'everybodyelse', 'event_label': element.id });
    }, false);
  }
};

const opaqueStyle = new Style({
  fill: new Fill({
      color: "#fff"
  })
});

const withCompositeOperation = (layer, operation) => {
  layer.on(["prerender", "precompose"], (e) => { e.context.globalCompositeOperation = operation; });
//  layer.on("postrender", (e) => { e.context.globalCompositeOperation = operation; });
  return layer;
}

// const logisticScaling = (pxs, params) => {
//   var x = (256 / (1 + Math.exp(-params.rate * (256*pxs[0][0] + pxs[0][1] + pxs[0][2]/256 - params.midpoint))) - params.minval) / params.norm;
//   return [255, 255, 255, Math.min(255, Math.floor(x))];
// }

// const linearScaling = (pxs, params) => [255, 255, 255, Math.min(255, Math.floor(127.5 * (256*pxs[0][0] + pxs[0][1] + pxs[0][2]/256) / params.midpoint))];

// thresholds is the 255 *upper limits* (where the last one should be infinity)
// STAGGERED
//const scalingTableLookup = (pxs, params) => [255, 255, 255, params.thresholds.findIndex((e) => (256*pxs[0][0] + pxs[0][1] + pxs[0][2]/256) <= e)];
// INTERLEAVED 5+3
//const scalingTableLookup = (pxs, params) => [255, 255, 255, params.thresholds.findIndex((e) => (((pxs[0][0]&248)<<7) | ((pxs[0][1]&248)<<2) | ((pxs[0][2]&248)>>>3)) <= e)];
// INTERLEAVED 4+4
const scalingTableLookup = (pxs, params) => [255, 255, 255, params.thresholds.findIndex((e) => (((pxs[0][0]&240)<<4) | (pxs[0][1]&240) | ((pxs[0][2]&240)>>>4)) <= e)];

// imagedata is the ENTIRE CANVAS so that will lead to a possibly more efficient but LATER draw
const tableLookup = (inputs, params) => {
  const out = new Uint8ClampedArray(inputs[0].data.length);
  out.fill(255);
  for (let i = 0; i < out.length/4; i++) {
    out[4*i + 3] = params.thresholds.findIndex((e) =>
      (((inputs[0].data[4*i]&240)<<4) | (inputs[0].data[4*i+1]&240) | ((inputs[0].data[4*i+2]&240)>>>4)) <= e);
  }
  return new ImageData(out, inputs[0].width, inputs[0].height);
}
const interpolateOpacity = (zoom, minZoom, maxZoom, maxOpacity, minOpacity) => minOpacity + (maxOpacity - minOpacity) * (1 - Math.min(1, Math.max(0, zoom - minZoom) / (maxZoom - minZoom)));

class OLMap extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      opacity: .75,
      midpoint: 1,
      rate: .02,
      nonlinear: true,
      thresholds: Array.from({ length: 256 }).fill(Number.MAX_VALUE),
//      source: 0,
      zoomScaling: 3,
//      debug: false,
      layer: this.props.communityIndex,
    };
  }

  // https://www.valentinog.com/blog/await-react/
  async componentDidMount () {
    this.backgroundLayer = new TileLayer({
        title: 'satellite (overview <a href="https://www.maptiler.com" target="_blank">&copy; Maptiler</a>, close-up <a href="https://www.mapbox.com/about/maps/" target="_blank">&copy; Mapbox</a>)',
//        visible: false,
//        type: 'base',
  //      className: 'layer background', // grayscaling by css-styling a separate canvas in ol6 only
        // ol5 alternative aka poor man's grayscale: reduce opacity in front of (black) background to dull satellite imagery colors (including white)
        opacity: this.state.opacity,
        source:
          new XYZ({
            tileSize: [512, 512],
            tileUrlFunction: (coordinate) => {
              const filename = (coordinate[0]) + '/' + coordinate[1] + '/' + (-1 - coordinate[2]);
              if (coordinate[0] <= 4) { // free OpenMapTiles preview til layer 5, but with 512 tiles that's actually layer 4
                return 'sat/' + filename + '.jpg';
              // } else if (coordinate[0] <= 7) {
              //   // maptiler's lighter water areas near the shores looks kinda not so nice from level 6 onwards, but the quality at 10-12 is better so keep it...
              //   return 'https://api.maptiler.com/tiles/satellite/' + filename + '.jpg?key=y2DjYn124z5IfjLvXdb3';
              } else {
                // mapbox uses the same images for ranges of zoom: sharp at 8 becomes blurry until 12, at 13 suddenly really sharp again
                // goes to 21: https://docs.mapbox.com/help/glossary/mapbox-satellite/
                return 'https://api.mapbox.com/v4/mapbox.satellite/' + filename + '@2x.jpg?access_token=pk.eyJ1Ijoia2V2aW5zdGFkbGVyIiwiYSI6ImNrY2VpeXdhdTA4djMydXN3MDV0ZDJ0amIifQ.6b5eLFc7eI7UcMuaj7e2LQ';
              }
            },
            maxZoom: 21,
            attributions: '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>',
            crossOrigin: 'anonymous',
          }),
        });
//       new TileLayer({
//         title: 'Mapbox satellite',
//         visible: false,
// //        type: 'base',
//         opacity: this.state.opacity,
//         source:
//           new XYZ({
//             // mapbox satellite has VERY white/yellow/bright deserts!
//             url: 'https://api.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}.png?access_token=pk.eyJ1Ijoia2V2aW5zdGFkbGVyIiwiYSI6ImNrY2VpeXdhdTA4djMydXN3MDV0ZDJ0amIifQ.6b5eLFc7eI7UcMuaj7e2LQ',
//             maxZoom: 21,
//             attributions: '<a href="https://www.mapbox.com/about/maps/" target="_blank">&copy; 2020 Mapbox and its suppliers</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a> <a href="https://www.mapbox.com/map-feedback/#/-74.5/40/10">Improve this map</a>',
//             crossOrigin: 'anonymous',
//           }),
//         }),
//       new TileLayer({
//         title: 'Bing satellite',
//         visible: false,
// //        type: 'base',
//         opacity: this.state.opacity,
//         source: new BingMaps({
//           key: "AnzJ8GUrq-Q-tkdVYWFWs-3H9pIyykpZBwnLXyGTXDA8WV6-1kg-veWxC9XBpMAt",
//           imagerySet: "Aerial",
//           maxZoom: 19,
//         }),
//       })];
//];
//    backgroundLayer.addFilter(new Colorize('grayscale'));
//    backgroundLayer.on('postcompose', (e) => {
//      console.log(e.context.globalCompositeOperation);
//    });
//    backgroundLayer.on('precompose', (e) => {
//      e.context.filter = 'grayscale(20%)';
//    });

    const useImageOperation = window.location.search.length > 1 && window.location.search[1] === 'i';

    const testWebP = () => {
      return new Promise(resolve => {
        const webP = new Image();
        webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
        webP.onload = webP.onerror = () => resolve(webP.height === 2);
      })
    };
    const imgProfile = ((window.location.search.length > 2 && window.location.search[2] === 'p') || !(await testWebP()) ) ? 'png' : 'webp';
//    const cv = document.createElement('canvas');
//    const webpSupport = cv.getContext && cv.getContext('2d') && cv.toDataURL('image/webp').indexOf('data:image/webp') == 0;

//    const useMapbox = (window.location.search.length > 3 && window.location.search[3] === 'p');
//    const tileProfile = window.location.search.substring(3);
    this.densitySource = new RasterSource({
      operation: useImageOperation ? tableLookup : scalingTableLookup,
      operationType: useImageOperation ? 'image' : 'pixel',
      sources: [new XYZ({
  //          url: "https://api.mapbox.com/v4/kevinstadler.81uh7tk6/{z}/{x}/{-y}.webp?sku=101eGmv9CQhd6&access_token=pk.eyJ1Ijoia2V2aW5zdGFkbGVyIiwiYSI6ImNrY2VpeXdhdTA4djMydXN3MDV0ZDJ0amIifQ.6b5eLFc7eI7UcMuaj7e2LQ",
        url: "gpw-v4.11/" + imgProfile + "/{z}/{x}/{-y}." + imgProfile,
//        url: "http://192.168.1.100:8000/webpnl/{z}/{x}/{-y}." + imgProfile,
        tileSize: [512, 512],
  //          projection: tileProfile === 'mercator' ? 'EPSG:3857' : 'EPSG:4326',
        attributions: '(<a href="https://creativecommons.org/licenses/by/4.0/">CC-BY-4.0</a>)&nbsp;NASA Socioeconomic Data and Applications Center&nbsp;(SEDAC)',
        minZoom: 1,
        maxZoom: 6,
        crossOrigin: 'anonymous',
      })]
        // jpeg SUCKS
        // new XYZ({
        //   url: "http://192.168.1.100:8000/" + tileProfile + "/j/{z}/{x}/{-y}.jpg",
        //   tileSize: [512, 512],
        //   projection: tileProfile === 'mercator' ? 'EPSG:3857' : 'EPSG:4326',
        //   minZoom: 1,
        //   maxZoom: 7,
        //   crossOrigin: 'anonymous',
        // }),
    });
//    console.log(density.getTileGrid());
//    this.densitySource.on('imageloadstart', (e) => console.log(e));
//    this.densitySource.on('error', (e) => console.log(e));
//    this.densitySource.on('imageloadstart', (e) => console.log(e));


    this.updateOperation({ target: { checked: this.state.nonlinear } });

//    densitySource.on('afteroperations', (e) => { console.log(e.data.foo); });
//    const scaleLinearly = (msb, lsb) => Math.min(255, 255*(msb*256 + lsb) / 2*midpoint);
//    setPopulationDensityTransform(1500);//{ f: scaleLinearly, midpoint: 250 });

    const densityLayer = new ImageLayer({
      source: this.densitySource,
      title: 'population density (<a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer">CC-BY-4.0</a>) <a href="https://sedac.ciesin.columbia.edu/data/set/gpw-v4-population-density-rev11/" target="_blank">SEDAC</a>',
    });

    const openMapTiles = new VectorTile({
      // use maptiler planet
      url: "https://api.maptiler.com/tiles/v3/{z}/{x}/{y}.pbf?key=y2DjYn124z5IfjLvXdb3",
//      url: "https://api.maptiler.com/tiles/v3-4326/{z}/{x}/{y}.pbf?key=y2DjYn124z5IfjLvXdb3",
//      projection: 'EPSG:4326',
      format: new MVT(),
//      minZoom: 3, // EXCLUSIVE, really only want 3 but go higher to avoid unnecessary initial downloads
      maxZoom: 14,
      attributions: '<a href="https://www.maptiler.com/copyright/" target="_blank" rel="noopener noreferrer">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
    });

    const residentialAreaLayer = new VectorTileLayer({
      source: openMapTiles,
      title: 'residential areas (&copy; <a href="https://www.maptiler.com/copyright/" target="_blank" rel="noopener noreferrer">MapTiler</a>/<a href="https://www.openstreetmap.org/copyright" target="_blank">OSM contributors</a>)',
      // landuse included from zoomLevel 4 (resolution 15000), good quality from zoomLevel 9
      minZoom: 7, // only 7.0 is excluded
      updateWhileInteracting: true,

      style: function(feature, resolution) {
        if (feature.get("layer") === "landuse" && feature.get("class") === "residential") {
          return opaqueStyle;
        }
      }
    });

    const residentialBuildingLayer = new VectorTileLayer({
      source: openMapTiles,
      title: 'residential buildings (&copy; <a href="https://www.maptiler.com/copyright/" target="_blank" rel="noopener noreferrer">MapTiler</a>/<a href="https://www.openstreetmap.org/copyright" target="_blank">OSM contributors</a>)',
      minZoom: 12, // excluding 12.0
      updateWhileInteracting: true,

      style: function(feature, resolution) {
        if (feature.get("layer") === "building") {
          return opaqueStyle;
        }
      }
    });

    const uninhabitedLayer = new VectorTileLayer({
      source: openMapTiles,
      title: 'exclude uninhabitable areas (&copy; <a href="https://www.maptiler.com/copyright/" target="_blank">MapTiler</a>/<a href="https://www.openstreetmap.org/copyright" target="_blank">OSM contributors</a>)',
      updateWhileInteracting: true,
      style: function(feature, resolution) {
        if (feature.get("layer") === "water" ||
           (feature.get("layer") === "landuse" && (feature.get("class") === "commercial" || feature.get("class") === "railway")) ||
           (feature.get("layer") === "park" && feature.get("class") === "nature_reserve") ||
           (feature.get("layer") === "landcover" && feature.get("class") === "wetland")) { // || class === "grass" ?
          return opaqueStyle;
        }
      }
    });

    // https://www.sessions.edu/color-calculator/ fixed points: mint(#aaffc3) cyan(#42d4f4)

    // https://sashamaps.net/docs/tools/20-colors/
//     const colors = {
//       red: [230, 25, 75],
// //      maroon: [128, 0, 0],
//       marred: [200, 13, 37], // average of the two above
// //      green: [60, 180, 75],
//       yellow: [255, 225, 25],
// //      blue: [0, 130, 200],
//       orange: [245, 130, 48],
//       cyan: [70, 240, 240], // instead of too-natural blue
//       magenta: [240, 50, 230], // TODO take some edge off this one...
// //      pink: [250, 190, 212], // too weak but still better than lavender...
// //      teal: [0, 128, 128],
// //      lavender: [220, 190, 255], // too weak
//       mint: [170, 255, 195], // instead of too-natural green

// //      nlime: [31, 255, 66],
// //      nyellow: [238, 247, 62],
// //      ncyan: [101, 246, 250],
// //      npink: [254, 0, 223],
// //      npurple: [173, 0, 249],
//     };
//    const getColors = (colorNames) => colorNames.map((name) => colors[name]);
    const createStyles = (colors) => colors.map((col) => new Style({
      fill: new Fill({
        color: col
      })
    })).sort(() => Math.random() - 0.5);

//    const fiveColors = createStyles(randomColorOrder(['marred', 'yellow', 'orange', 'cyan', 'magenta']));
//    const sixColors = createStyles(getColors(['marred', 'yellow', 'orange', 'cyan', 'magenta', 'mint']));
// https://www.sessions.edu/color-calculator-results/?colors=c8ff8a,36a8bf,cc3985,ffad8a
    const neonColors = createStyles([[200, 255, 138], [54, 168, 191], [255, 222, 33], [204, 57, 133], [255, 173, 138]]);
    const sixColors = createStyles([[200, 255, 138], [54, 168, 191], [255, 222, 33], [204, 57, 133], [255, 173, 138], [199, 34, 217]]);
    // complement of yellow might be #c722d9 ? 
//    const sevenColors = createStyles(randomColorOrder(['marred', 'yellow', 'orange', 'cyan', 'magenta', 'pink', 'mint']));

    const a0Source = new VectorTile({
//      url: useMapbox ? "https://api.mapbox.com/v4/kevinstadler.80zw7l2g/{z}/{x}/{y}.vector.pbf?access_token=pk.eyJ1Ijoia2V2aW5zdGFkbGVyIiwiYSI6ImNrY2VpeXdhdTA4djMydXN3MDV0ZDJ0amIifQ.6b5eLFc7eI7UcMuaj7e2LQ" : "ic-tiles/a0/{z}/{x}/{y}.pbf",
      url: "ic-tiles/a0/{z}/{x}/{y}.pbf",
//      crossOrigin: 'anonymous',
      format: new MVT(),
      minZoom: 0, // EXCLUSIVE
      maxZoom: 9
    });

    const a1Source = new VectorTile({
      url: "ic-tiles/a1/{z}/{x}/{y}.pbf",
//      crossOrigin: 'anonymous',
      format: new MVT(),
      minZoom: 0, // EXCLUSIVE
      maxZoom: 5 // 9 if using nominatim
    });

    const createCommunityLayer = (name, source, style) => new VectorTileLayer({
      title: name,
      type: 'base',
      visible: false,
      source: source,
      renderMode: 'image',
      style: style,
//      updateWhileAnimating: true,
      updateWhileInteracting: true,
    });

    this.communityLayers = [
      new VectorTileLayer({
        title: 'humans (no color)',
        type: 'base',
        visible: false,
//        updateWhileAnimating: true,
        updateWhileInteracting: true,
      }),
      createCommunityLayer('countries (5 colors)', a0Source, (feature) => neonColors[feature.get("col1") - 1]),
//      createCommunityLayer('states/provinces (7 colors)', a1Source, (feature) => sevenColors[feature.get("col0") - 1]),
      createCommunityLayer('states/provinces (6 colors)', a1Source, (feature) => sixColors[feature.get("col1") - 1]),
//      createCommunityLayer('states/provinces (A1-level units)', a1Source, (feature) => sixColors[feature.get("col2") - 1]),
    ];
    this.communityLayers[this.props.communityIndex].set('visible', true);

//     const oldCommunityLayer = new VectorTileLayer({
//       title: 'A0-level administrative units (old)',
// //      type: 'base',
//       visible: false,
//       source: new VectorTile({
//         url: "https://kevinstadler.github.io/osm-admin-boundary-vector-tiles/{z}/{x}/{y}.pbf",
//         format: new MVT(),
//         maxZoom: 10
//       }),
//       renderMode: 'image',
//       style: function(feature, resolution) {
//         return sevenColors[feature.get("color7") - 1];
//       }
//     });

    const view = new View({
//      projection: 'EPSG:4326',
      center: fromLonLat(this.props.center),
      zoom: this.props.zoom,
      minZoom: 1, // EXCLUSIVE!?
      maxZoom: this.props.maxZoom
    });

    this.communityLayers.forEach((l, i) => {
      l.on('change:visible', (e) => {
        if (e.target.getVisible()) {
          this.setState({ layer: i });
          this.props.setHash(view.getZoom(), toLonLat(view.getCenter()), i);
          window.gtag('event', 'select_content', { 'app_name': 'imaginedcommunities', 'content_type': 'chooseoverlay', 'items': [{ 'id': i }] });
        }
      });
    });

    const textStyle = new Style({
      text: new Text({
        fill: new Fill({ color: "#fff" }),
        font: "italic 1em sans-serif"
      })
    });

    // const communityLabelLayer = new VectorTileLayer({
    //   source: a0Source,
    //   title: 'community name labels',
    //   visible: false,
    //   declutter: true,
    //   style: function(feature, resolution) {
    //     textStyle.getText().setText(feature.get("name"));
    //     textStyle.setZIndex(0); // for declutter
    //     return textStyle;
    //   }
    // });

    const placeLabelLayer = new VectorTileLayer({
      source: openMapTiles,
      title: 'place names (&copy; <a href="https://www.maptiler.com/copyright/" target="_blank">MapTiler</a>/<a href="https://www.openstreetmap.org/copyright" target="_blank">OSM contributors</a>)',
//      visible: false,
      minZoom: 3.5,
//      maxResolution: view.getResolutionForZoom(3.5), // don't show labels on initial map
      declutter: true,
      style: function(feature, resolution) {
        if (feature.get("layer") === "place" && feature.get("rank") <= view.getZoom() - 2 &&
            // anything but islands, hamlets and suburbs
            ["city", "town", "village", "neighbourhood", "isolated_dwelling"].includes(feature.get("class"))) {
//              console.log(feature.get("rank") + feature.get("class") +feature.get("name"));
          textStyle.getText().setText(feature.get("name"));
          textStyle.setZIndex(feature.get("rank")); // for declutter
          return textStyle;
        }
      }
    });

    // backgroundLayer.on('postrender', (e) => {
    //   e.context.globalCompositeOperation = 'multiply';
    //   const vectorContext = getVectorContext(e);
    //   communitySource.getFeaturesInExtent(view.calculateExtent()).forEach((f) => {
    //     vectorContext.drawFeature(f, communityStyles[f.get('mapcolor7') - 1]);
    //   });
    //   e.context.globalCompositeOperation = 'source-over';
    // });

//     communityLayer.on('postrender', (e) => {
//       console.log(e);
// //      densityLayer.getRenderer().context = e.context.canvas.getContext('2d');
//       e.context.globalCompositeOperation = 'multiply';
//       console.log(densityLayer.render(e.frameState, e.context.canvas));
//     });

    const setLayerOpacities = () => {
      // had it as low as .5 for nice and dark, as high as .65
//      this.backgroundLayers.forEach((layer) => layer.setOpacity(interpolateOpacity(view.getZoom(), 3, 7, .5, .75)));
//      this.backgroundLayer.setOpacity(interpolateOpacity(view.getZoom(), 3, 7, .75, .75));

      // this call will also recalculate thresholds based on the new zoom level
      this.setParamsAndUpdateThresholds({ opacity: interpolateOpacity(view.getZoom(), 3, 7, .5, .9) });
      // TODO adjust logistic scaling parameter instead (decrease rate OR increase midpoint as zooming in)
      // also set opacity though, like a double trimming whammy kinda
//      this.setThresholds(this.state.nonlinear, this.state.midpoint, interpolateOpacity(view.getZoom(), 3, 10, this.state.rate, this.state.rate / this.state.zoomScaling));

      densityLayer.setOpacity(interpolateOpacity(view.getZoom(), 3, 10, 1, .25)); // data stops at 7, 3-9 so there's some overlap with better data sources

      // 0 at zoom 7, turn it up then back again
      if (view.getZoom() <= 10) {
        residentialAreaLayer.setOpacity(interpolateOpacity(view.getZoom(), 7, 9, 0, .5));
      } else {
        residentialAreaLayer.setOpacity(interpolateOpacity(view.getZoom(), 9, 17, .5, .1));
      }
      residentialBuildingLayer.setOpacity(interpolateOpacity(view.getZoom(), 12, 18, 0, .5));
    }

    view.on('change:resolution', setLayerOpacities);
    setLayerOpacities();

    const resetToEitherPole = () => {
      // like https://github.com/openlayers/openlayers/blob/v6.4.1/src/ol/control/Rotate.js#L127
      const rotation = this.map.getView().getRotation();
      this.map.getView().animate({
        rotation: Math.abs(rotation) === Math.PI ? 0 : Math.PI, // TODO round to nearest pole instead
        duration: 500,
        easing: easeOut,
      });
    };

    this.map = new Map({
      layers: [
        new Group({
          title: 'populated areas',
          layers: [
            withCompositeOperation(densityLayer, "source-over"),
            withCompositeOperation(uninhabitedLayer, "destination-out"),
            // high-zoom overlays
            withCompositeOperation(residentialAreaLayer, "source-over"),
            withCompositeOperation(residentialBuildingLayer, "source-over"),
          ]}),
        new Group({
          title: 'community coloration',
          layers: this.communityLayers.map((l) => withCompositeOperation(l, "source-in"))
        }),
        new Group({
          title: 'labels',
          layers: [
//            withCompositeOperation(communityLabelLayer, "source-over"),
            withCompositeOperation(placeLabelLayer, "source-over")
          ]}),
        new Group({
          title: 'background',
          layers: [withCompositeOperation(this.backgroundLayer, "destination-over")]
//          layers: [ this.backgroundLayers[0] ].map((layer) => withCompositeOperation(layer, "destination-over"))
        }),
      ],

      controls: [
        new Zoom(),
        new FullScreen(),
        new Rotate({ autoHide: false, resetNorth: resetToEitherPole }),
        new GenericControl(document.getElementById('attributions'), this.props.toggleOverlay),
        new LayerSwitcher({
          reverse: false,
          tipLabel: 'community overlays', // Optional label for button
          groupSelectStyle: 'none' // Can be 'children' [default], 'group' or 'none'
        }),
        new ScaleLine({
          units: 'metric'
        }),
      ],
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
      target: this.props.id,
      view: view,
    });

    // gtag listeners
    this.map.on('moveend', (e) => {
      this.props.setHash(e.target.getView().getZoom(), toLonLat(e.target.getView().getCenter()), this.state.layer);
      window.gtag('event', 'select_content', { 'app_name': 'imaginedcommunities', 'content_type': 'panzoom', 'items': [{ 'id': window.location.hash }] });
    });

    [densityLayer, uninhabitedLayer, residentialAreaLayer, residentialBuildingLayer, placeLabelLayer, this.backgroundLayer].forEach((l) => {
      l.on('change:visible', (e) => {
        const to = e.target.get('title').indexOf('(') - 1;
        const layername = e.target.get('title').substring(0, to > 0 ? to : e.target.get('title').length);
        window.gtag('event', 'select_content', { 'app_name': 'imaginedcommunities', 'content_type': 'togglelayer', 'items': [{ 'name': layername, 'variant' : e.target.getVisible() }] });
      });
    });
  }

  shouldComponentUpdate = (newProps, newState) => {
    if (newState !== this.state || newProps.debug !== this.props.debug) {
      return true;
    }
    this.map.updateSize();
    if (newProps.center !== this.props.center) {
      // switch overlay layer to a colored one
      if (this.communityLayers[0].get('visible')) {
        this.communityLayers[0].set('visible', false);
        this.communityLayers[1].set('visible', true);
      }

      // from https://openlayers.org/en/latest/examples/animation.html#136
      const duration = 4000;
      this.map.getView().animate({
        center: fromLonLat(newProps.center),
        duration: duration,
        easing: inAndOut,
      });
      this.map.getView().animate({
        // zoom half-way out to zoom 2?
        zoom: this.map.getView().getZoom() - Math.max(1, (this.map.getView().getZoom() - 2))/2,
        duration: duration / 2,
        easing: inAndOut,
      },
      {
        zoom: newProps.zoom,
        duration: duration / 2,
        easing: inAndOut,
      });
    }
    return false;
  }

  getLogisticScalingParameters = (midpoint, rate, headroom) => {
//    const rate = Math.log(1 / headroom - 1) / midpoint;
    // calculate value at t = 0
    const minval = 256 / (1 + Math.exp(rate * midpoint));
    // normalized = (val - minval) / (range - minval)
    const norm = (256 - minval) / 256;
    return {
      midpoint: midpoint,
      rate: rate,
      minval: minval,
      norm: norm,
    };
  }

  // const x = Array.from({ length: 300 }).map((foo, i) => logisticScaling([[Math.floor(i / 256), i % 256, 0]], getLogisticScalingParameters(300, .05))[3]);
  // console.log(x);
  // console.log(getLogisticScalingParameters(300, .05));
  // console.log(logisticScaling([[0, 130, 0]], getLogisticScalingParameters(300, .05)));
  // console.log(logisticScaling([[1, 45, 0]], getLogisticScalingParameters(300, .05)));

//    densitySource.setOperation((pxs, data) => { var x = Math.min(255, Math.ceil(255*(pxs[0][0]*256 + pxs[0][3]) / (2*data.midpoint))); data.foo[x] = data.foo[x]+1; return [255, 255, 255, x] });

  setParamsAndUpdateThresholds = (paramUpdates) => {
    const newState = {...this.state, ...paramUpdates};

    const effectiveRate = this.map ? interpolateOpacity(this.map.getView().getZoom(), 4, 10, newState.rate, newState.rate / newState.zoomScaling) : newState.rate;

    const thresholds = this.state.thresholds;
    if (newState.nonlinear) {
      const params = this.getLogisticScalingParameters(newState.midpoint, effectiveRate);
      for (let i = 0; i < 255; i++) {
        thresholds[i] = - Math.log(255/(i*params.norm + params.minval) - 1) / effectiveRate + params.midpoint;
      }
    } else {
      for (let i = 0; i < 255; i++) {
        thresholds[i] = Math.max(0, newState.midpoint + (.05 / effectiveRate) * (i - 127.5));
      }
    }
//    thresholds[256] = newState.source;

    newState.thresholds = thresholds;
    this.setState(newState);
    this.densitySource.on('beforeoperations', (e) => {
      e.data.thresholds = thresholds;
    });
    this.densitySource.changed();
  }

  updateMidpoint = (e) => {
    const midpoint = parseFloat(e.target.value);
    this.setParamsAndUpdateThresholds({ midpoint: midpoint });
  }

  updateRate = (e) => {
    this.setParamsAndUpdateThresholds({ rate: e.target.value });
  }

  updateZoomScaling = (e) => {
    this.setParamsAndUpdateThresholds({ zoomScaling: e.target.value });
  }

  // updateOpacity = (e) => {
  //   this.setState({ opacity: 1 - e.target.value }); // TODO can remove later
  //   this.backgroundLayers.forEach((layer) => layer.setOpacity(1 - e.target.value));
  // }

  // toggleDebug = () => {
  //   this.setState({ debug: ! this.state.debug });
  // }

  updateOperation = (e) => {
    this.setParamsAndUpdateThresholds({ nonlinear: e.target.checked });
//    this.densitySource.setOperation(e.target.checked ? logisticScaling : linearScaling);
//    this.densitySource.changed();
  }

  // updateSource = (e) => {
  //   this.setParamsAndUpdateThresholds({ source: e.target.value });
  // }

  render = () => {
    // generate svg <rect />s
//      const y = logisticScaling([[Math.floor(4*i / 256), 4*i % 256, 0]], params)[3];
//      const y = (this.state.nonlinear ? logisticScaling : linearScaling)([[Math.floor(2*i / 256), 2*i % 256, 0]], params)[3];
    return (
      <>
      <div className="map" id={this.props.id} style={{ height: this.props.height + 'px' }}>
        <div id="attributions" className="ol-unselectable ol-control"><button type="button" title="What is this map?"><span>?</span></button></div>
      </div>
      { this.props.debug && <>
        <div style={{ position: 'absolute', left: '10px', bottom: '220px', backgroundColor: '#fff7' }}><b>population density scaling function</b></div>
        <svg id="function" style={{ bottom: '85px', backgroundColor: '#0007' }} width="250" height="129" xmlns="http://www.w3.org/2000/svg">
          {Array.from({ length: 250 }).map((foo, i) => <rect x={i} y={129 - this.state.thresholds.findIndex((e) => 4*i <= e)/2} width="1" height="1" fill="white" />)}
          <rect x={this.state.midpoint/4} y="0" width="1" height="128" fill="#aaa" />
        </svg>
        <div style={{ position: 'absolute', left: '10px', bottom: '60px', backgroundColor: '#fff7' }}>inflection point at <b>{this.state.midpoint}</b> ppl/km2, rate <b>{this.state.rate}</b>.</div>
        <input type="checkbox" defaultChecked={this.state.nonlinear} onChange={this.updateOperation} />
        <div style={{ position: 'absolute', left: '35px', bottom: '35px', backgroundColor: '#fff7' }}>{this.state.nonlinear ? 'logistic' : 'linear'}</div>
        <input style={{ left: '95px' }} title="adjust inflection point" type="range" min={1} max={200} step={1} defaultValue={this.state.midpoint} onChange={this.updateMidpoint} />
        <input style={{ left: '235px' }} title="adjust rate" type="range" min={0.005} max={.1} step={.005} defaultValue={this.state.rate} onChange={this.updateRate} />
      </>}
      </>
    );
  }
}
//      <input style={{ left: '285px' }} type="number" min="0" max="4" step="1" value={this.state.source} onChange={this.updateSource} />
// automatic background dimming: <b>{Math.round(100*(1 - this.state.opacity))/100}</b>)
//        <input style={{ left: '315px' }} type="range" min={1} max={50} step={1} defaultValue={this.state.zoomScaling} onChange={this.updateZoomScaling} />
//      <input id="darkness" type="range" min={0} max={.7} step={.05} defaultValue={1 - this.state.opacity} onChange={this.updateOpacity} />
export default OLMap;
